/**
 * Central place for real contact / social links, sourced from Murilo's resume.
 */
export const profile = {
  name: "Murilo Marques",
  fullName: "Murilo Henrique Marques Bento Santos",
  email: "murilohmbsantos@gmail.com",
  phone: "+55 81 99577-8733",
  phoneHref: "tel:+5581995778733",
  github: "https://github.com/Hosz",
  githubHandle: "github.com/Hosz",
  linkedin: "https://www.linkedin.com/in/murilo-henrique2004",
  linkedinHandle: "linkedin.com/in/murilo-henrique2004",
  kofi: "https://ko-fi.com/murilo_marques",
  kofiHandle: "ko-fi.com/murilo_marques",
  resumeUrl: "/resume/murilo-resume.pdf",
  location: "Recife, PE",
};
